import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3155eb1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-time-show-wrap" }
const _hoisted_2 = { class: "time-item" }
const _hoisted_3 = {
  key: 0,
  class: "frequency-day"
}
const _hoisted_4 = {
  key: 1,
  class: "frequency-week"
}
const _hoisted_5 = {
  key: 2,
  class: "frequency-month"
}
const _hoisted_6 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskTime, (item, index) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_ctx.frequency === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('common.frequencyDay')), 1))
          : (_ctx.frequency === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('common.frequencyWeek', { n: _ctx.formatNumberToCn(item.target) })), 1))
            : (_ctx.frequency === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('common.frequencyMonth', { n: String(item.target).padStart(2, '0') })), 1))
              : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(_ctx.formatMinuteToTime(item.start_min)) + "-" + _toDisplayString(_ctx.formatMinuteToTime(item.end_min)), 1),
        (index < _ctx.taskTime.length - 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, ";"))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ]))
}